import type { QuerySettings } from '@customTypes/index';
import { useQuery } from '@tanstack/react-query';

import { getRegistrationRequestList } from './request';

export const useGetRegistrationRequestListQuery = (
  settings?: QuerySettings<typeof getRegistrationRequestList>
) =>
  useQuery({
    queryKey: ['GetRegistrationRequestList'],
    queryFn: () =>
      getRegistrationRequestList({
        config: settings?.config
      }),
    ...settings?.options
  });
